module.exports = __webpack_public_path__ + "img/emoji-bullet.ecfa4057.svg";